import {
  CrudViewFormItemType,
  CrudFormConfig,
  CrudFormTextBoxItem,
  TextBoxType,
  FormLayout,
  CrudFormButtonItem,
  ActionBehavior,
  InputSize,
  ButtonType,
  ButtonSize,
} from '@rappider/rappider-components/utils';
import { Validators } from '@angular/forms';
import { PATH_DEFINITIONS } from '../../definitions/path-definition';
import { CrudFormInputGroupItem } from 'libs/components/src/lib/utils/edit-form/crud-form-input-group-item.interface';
import { IconType } from '../../definitions/icon-type.enum';

export const LOGIN_CONFIG: CrudFormConfig = {
  items: [
    <CrudFormTextBoxItem>{
      title: 'Email',
      fieldName: 'username',
      placeholder: 'Email',
      type: CrudViewFormItemType.TextBox,
      required: true,
      index: 1,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'AUTHENTICATION_MODULE.LOGIN_COMPONENT.EMAIL_REQUIRED'
        }
      ],
      size: InputSize.Default
    },
    <CrudFormInputGroupItem>{
      title: 'Password',
      fieldName: 'password',
      type: CrudViewFormItemType.InputGroup,
      textbox: {
        type: TextBoxType.Password,
        placeholder: 'SHARED.PASSWORD'
      },
      suffixIcon: {
        name: 'eye',
        type: IconType.NgZorro,
        isClickable: true
      },
      index: 4,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'AUTHENTICATION_MODULE.LOGIN_COMPONENT.PASSWORD_REQUIRED'
        }
      ],
      size: InputSize.Default
    },
    <CrudFormButtonItem>{
      text: 'AUTHENTICATION_MODULE.FORGOT_PASSWORD',
      type: CrudViewFormItemType.Button,
      behavior: ActionBehavior.Route,
      redirectUrl: `${PATH_DEFINITIONS.AUTH.FORGOT_PASSWORD}`,
      buttonType: ButtonType.Link,
      index: 5,
      cssStyle: {
        padding: 0,
        float: 'right'
      }
    }
  ],
  itemSettings: {
    inputComponentSize: {
      xs: 24
    },
    labelComponentSize: {
      xs: 24
    }
  },
  submitButton: {
    text: 'AUTHENTICATION_MODULE.LOGIN',
    size: ButtonSize.Default,
    block: true,
    type: ButtonType.Primary
  },
  formLayout: FormLayout.Vertical
};

export const LOGIN_FEEDBACK_CONFIG = {
  title: 'AUTHENTICATION_MODULE.LOGGING_IN',
  icon: 'fas fa-spinner fa-spin',
};
